module.exports = __webpack_public_path__ + "img/vehicles-outline.0d724b14.svg";